import { useMatches } from '@remix-run/react'

interface BreadcrumbBackRoute {
  name: string
  href: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

export function useBreadcrumbBackRoute(): BreadcrumbBackRoute {
  const matches = useMatches()
  const current = matches[matches.length - 1]
  const previous = matches.length > 1 ? matches[matches.length - 2] : null
  const prevHandle = previous?.handle as { breadcrumb?: string } | undefined

  const isInvalid =
    !previous ||
    !previous.pathname ||
    previous.pathname === current.pathname ||
    !prevHandle?.breadcrumb ||
    (matches.length === 2 && previous.pathname === '/')

  if (isInvalid) {
    return {
      name: 'Voltar',
      href: '#',
      onClick: (e) => {
        e.preventDefault()
        window.location.href = '/'
      },
    }
  }

  return {
    name: prevHandle?.breadcrumb || 'Voltar',
    href: previous.pathname,
  }
}
